import { Card, CardBody } from "@windmill/react-ui";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import "components/dashboard/salesCardItem.css";
import { useHistory } from "react-router-dom";


const SalesCardItemtwo = ({
    mode,
    title,
    Icon,
    Img,
    className,
    price,
    currency,
    loading,
    title2,
    onNavigation,
    daytitle,
    type,
    passDates,
    current_month,
    cardtype


}) => {
   
    const history = useHistory();
    const handleNavigate = () => {
        const params = new URLSearchParams();
        const format = (d) =>
            `${String(d.getDate()).padStart(2, "0")}-${String(
                d.getMonth() + 1
            ).padStart(2, "0")}-${d.getFullYear()}`;
        const today = new Date();
        if (type) {
            params.append("type", type);
        }
        if (current_month) {
            const start = new Date(today.getFullYear(), today.getMonth(), 1);
            const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            params.append("start", format(start));
            params.append("end", format(end));
        }
        if (cardtype) {
            params.append("cardtype", cardtype)
        }
        else if (passDates) {
            const later = new Date(today);
            later.setDate(today.getDate() + 30);
            params.append("start", format(today));
            params.append("end", format(later));
        }
        history.push({
            pathname: onNavigation,
            search: params.toString() ? `?${params.toString()}` : "",
        });
    };


    return (
        <>
            {loading ? (
                <Skeleton
                    count={4}
                    height={40}
                    className="dark:bg-gray-800 bg-gray-200"
                    baseColor={mode === "dark" ? "#010101" : "#f9f9f9"}
                    highlightColor={mode === "dark" ? "#1a1c23" : "#f8f8f8"}
                />
            ) : (
                <Card className="flex justify-center h-full" onClick={() => handleNavigate()}>
                    <CardBody
                        className={`cursor-pointer border border-gray-200 dark:border-gray-800 w-full p-6 rounded-lg ${className}`}
                    >
                        <div className="">
                            <div className="salestopcard-flex">
                                <p className="mb-3 text-lg font-medium text-gray-900 dark:text-gray-100">
                                    {title2 ? (title2) : "-"}
                                </p>
                                <div className="sales-icon-div">
                                    {Icon && <Icon />}
                                    {!Icon && Img && (
                                        <img
                                            src={Img}
                                            alt="icon"
                                            className="object-contain card-icons"
                                        />
                                    )}
                                </div>

                            </div>
                            <div className="flex items-baseline justify-between mt-3">
                                <p className="text-3xl mb-0 mt-1 font-bold leading-none dark:text-black-100">
                                    {currency}
                                    {Number(price)}
                                </p>
                                <p className="mb-0" style={{ fontSize: "16px", fontWeight: "600", color: "#3B82F6" }}>{daytitle}</p>

                            </div>



                            {/* OPTIONAL BREAKDOWN (KEEP COMMENTED IF NOT USED) */}
                            {/* 
              <div className="flex justify-center text-xs mt-3 text-gray-50">
                <span className="px-2">Cash: {currency}{cash}</span>
                <span className="px-2">Card: {currency}{card}</span>
                <span className="px-2">Credit: {currency}{credit}</span>
              </div> 
              */}
                        </div>
                    </CardBody>
                </Card>
            )}
        </>
    );
};

export default SalesCardItemtwo;
